import RoundedButton2 from './RoundedButton2.js';
import { Colors } from '../consts/Colors.js';

export default class PopupFin extends Phaser.GameObjects.Container {
    constructor(scene, text, centerX) {
        super(scene, 0, 0, []);

        scene.add.existing(this);
        this.scene = scene;
        this.text = text;
        
        this.introBack = this.scene.add.rectangle(0, 0, 1920, 1080, Colors.Elmt.DarkBlue, 0.5).setOrigin(0, 0);
        this.add(this.introBack);
        this.intoPopUp = this.scene.add.rexRoundRectangle(centerX, 539, 934, 352, 47, Colors.Elmt.White).setOrigin(0.5);
        this.add(this.intoPopUp);
    
        let titre = {
            text: this.text,
            config: { size: '32px', fontFamily: 'MassiliaMediumOblique', align: 'center', color: Colors.Text.DarkBlue, backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 790 }
        }
        this.introTitre = this.scene.createTextElement(centerX, 500, titre)
        this.add(this.introTitre);
        this.introBtn = new RoundedButton2(this.scene, centerX, 650, 212, "Continuer", Colors.Text.White, Colors.Elmt.DarkBlue);
        this.add(this.introBtn);
        
    }
}